export const ROLE_PERMISSIONS = {
    owner: 3,
    admin: 2,
    member: 1,
    disabled: 0,
    pending: 0,
};
export const LOGIN_ROLES = ['owner', 'admin', 'member'];
export const canLogin = (role) => LOGIN_ROLES.includes(role);
/** Roles that manage the instance and see every server; members see only their own activity. */
export const STAFF_ROLES = ['owner', 'admin'];
export const isStaff = (role) => STAFF_ROLES.includes(role);
export const hasMinRole = (userRole, required) => ROLE_PERMISSIONS[userRole] >= ROLE_PERMISSIONS[required];
export const isOwner = (role) => role === 'owner';
export const isActive = (role) => canLogin(role);
/** Supported media types */
export const MEDIA_TYPES = [
    'movie',
    'episode',
    'track',
    'live',
    'photo',
    'trailer',
    'unknown',
];
/**
 * Default values for stream detail fields (all null).
 * Use with spread operator for test fixtures and initial values.
 */
export const DEFAULT_STREAM_DETAILS = {
    sourceVideoCodec: null,
    sourceAudioCodec: null,
    sourceAudioChannels: null,
    sourceVideoWidth: null,
    sourceVideoHeight: null,
    sourceVideoDetails: null,
    sourceAudioDetails: null,
    streamVideoCodec: null,
    streamAudioCodec: null,
    streamVideoDetails: null,
    streamAudioDetails: null,
    transcodeInfo: null,
    subtitleInfo: null,
};
/** The people each location of the /stats/locations list carries; the list draws this many avatars. */
export const LOCATION_LIST_PEOPLE = 3;
/** Ordered restore phases (excludes 'failed') for progress UI rendering. */
export const RESTORE_PHASES = [
    'validating',
    'creating_restore_point',
    'shutting_down',
    'restoring_database',
    'running_migrations',
    'rebuilding_aggregates',
    'restarting',
    'complete',
];
//# sourceMappingURL=types.js.map